import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanSettingsScenariosRoute: InvariantJiraRoute = {
	name: 'plan-settings-scenarios',
	path: '/jira/plans/:planId/scenarios/:scenarioId/settings/scenarios',
};
